import React from "react";
import Common from "./../../Common";
import { Link, Redirect } from "react-router-dom";
import Header from "./../../Header";
import { getNotificationList } from "../../Actions/Notifications/manageNotificationActions.js";
import { connect } from "react-redux";
import Search from "../UI/Search";
import Back from "../UI/Back";
import { Card, Col, Container, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import BtnCellRenderer from "./BtnCellRenderer";
import NotificationMessage from "./NotificationMessage";
import TimeSvg from "../UI/svg/TimeSvg";

const customStyles = {
  rows: {
    style: {
      minHeight: "60px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "60px", // override the cell padding for head cells
      paddingRight: "5px",
      fontSize: "14px",
      fontFamily: "poppins-medium",
      minHeight: "0px",
    },
  },
  cells: {
    style: {
      paddingLeft: "60px", // override the cell padding for data cells
      paddingRight: "5px",
      fontSize: "13px",
      fontFamily: "poppins-regular",
      whiteSpace: "unset",
    },
  },
};
class ManageNotifications extends Common {
  constructor(props) {
    super(props);
    var has_local_data = this.getFromStorage("encdata") ? 1 : 0;
    var localdata = has_local_data
      ? this.decrypt(this.getFromStorage("encdata"), 0)
      : "";
    this.state = {
      email: "",
      password: "",
      message: "",
      apiUrl: this.decryptconfigdata("apiUrl"),
      role: has_local_data ? localdata.data.role : [],
      localdata: localdata,
      message_type: "",
      message: "",
      data: [],
      fields: {},
      loading: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      search: "",
      toggledClearRows: false,
      isLoading: "data-loader",
      filteredList: [],
      filteredData: [],
      app_token: props?.location?.state ? this.getCommonData().app_token : null,
      attribute_set_key: props?.location?.state
        ? props.location.state.attribute_set_key
        : null,
      attribute_set_name: props?.location?.state
        ? props.location.state.attribute_set_name
        : null,
      agGridData: [],
      app_token1: "",
      attribute_set_key1: "",
      event_id: "",
      notification_tag_code: "",
      notification_variable: "",
      notification_status: [],
      notification_message: [],
      columnDefs: [
        {
          headerName: "Notification Name",
          field: "notification_name",
          width: 80,
          sortable: true,
        },
        {
          headerName: "Event Name",
          field: "event_name",
          width: 80,
          sortable: true,
        },
        {
          headerName: "Status",
          field: "notification_status",
          width: 20,
          cellRenderer: (params) => {
            return this.statusCheckCellRenderer(params);
          },
        },
        {
          headerName: "Actions",
          field: "notification_tag_code",
          width: 20,
          cellRenderer: (params) => {
            return this.editCellRenderer(params);
          },
        },
      ],
    };
    this.columns = [
      {
        name: "Notifications",
        selector: "name",
        sortable: true,
        cell: (row) => (
          <Link
            to={`/edit-notification/${row.config_name.replace(
              "notification_",
              ""
            )}`}
          >
            {row.name}
          </Link>
        ),
      },
      {
        name: "Type",
        selector: "type",
        sortable: true,
        cell: (row) => row.type,
      },
      {
        name: "Actions",
        selector: "config_value",
        sortable: true,
        paddingRight: "40px",
        cell: (row) => (
          <i
            className={
              row.config_value == 1
                ? "fa-toggle-on fas fa-2x pointer"
                : "fa-toggle-off fas fa-2x pointer"
            }
            {...(row.config_value == 1 ? `ON` : `OFF`)}
            data-status={row.config_value}
            data-id={row.config_name}
          ></i>
        ),
      },
    ];

    this.InitiatieSearch = this.InitiatieSearch.bind(this);
    this.sortBy = this.sortBy.bind(this);
    this.editCellRenderer = this.editCellRenderer.bind(this);
    this.statusCheckCellRenderer = this.statusCheckCellRenderer.bind(this);
  }
  statusCheckCellRenderer = (params) => {
    const status = params.value;
    const { apiUrl, app_token1, attribute_set_key1, agGridData } = this.state;
    const temp = agGridData.map((val) => {
      return val;
    });
    const newData = agGridData.find((item) => {
      return item.notification_tag_code === params.data.notification_tag_code;
    });

    return (
      <>
        <BtnCellRenderer
          apiUrl={apiUrl}
          status={status}
          app_token={app_token1}
          attribute_set_key={attribute_set_key1}
          event_id={newData.event_id}
          notification_tag_code={newData.notification_tag_code}
          NotificationMessage={this.NotificationMessage}
        />
      </>
    );
  };
  editCellRenderer = (params) => {
    const { app_token, attribute_set_key, attribute_set_name, agGridData } =
      this.state;
    const newData = agGridData.find((item) => {
      return item.notification_tag_code === params.data.notification_tag_code;
    });
    return (
      <>
        <div
          class="muBtn icon-only"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          title="Edit"
        >
          <Link
            to={{
              pathname: `/${attribute_set_key}/manage-notifications/edit`,
              state: {
                app_token,
                attribute_set_key,
                event_id: newData.event_id,
                event_name: newData.event_name,
                attribute_set_name,
                notification_tag_code: newData.notification_tag_code,
                notification_variable: newData.notification_variable,
              },
            }}
          >
            <span class="svg">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </Link>
        </div>
      </>
    );
  };

  sortBy = () => {
    var e = document.getElementById("sortfilter");
    var selected = e.options[e.selectedIndex].value;

    if (selected === "all") {
      this.getNotificationList();
    } else if (selected === "internal") {
      this.state.fields["search"] = selected;
      this.props.getNotificationList(this.state.fields);
    } else {
      this.state.fields["search"] = selected;
      this.props.getNotificationList(this.state.fields);
    }
  };
  InitiatieSearch(event) {
    var obj = this;
    this.setState({ search: event.target.value });
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(function () {
      obj.getNotificationList();
    }, 500);
  }
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleSearch = (e) => {
    e.preventDefault();
    const { data, search2 } = this.state;
    this.state.fields["search"] = this.state.search2;
    this.props.getNotificationList(this.state.fields);
  };

  handleRowSelected(state) {
    if (state.selectedRows.length) {
      var selectedvalues = state.selectedRows.map(function (value, index) {
        return value.group_uuid;
      });
      this.setState({ selectedrows: selectedvalues });
    }
  }
  async componentDidMount() {
    const data = this.getCommonData();
    var addnotication = localStorage.getItem("addnotication");
    if (addnotication == 1) {
      const notf_show = new Object();
      notf_show.code = 200;
      notf_show.msg = "Notification Added Successfully!";
      console.log("Manage Notifications : ", notf_show);
      localStorage.setItem("addnotication", 0);
      this.NotificationMessage(notf_show);
    }

    document.title = "Tattle | Notifications";
    if (!localStorage.getItem("userLogin")) {
      this.setState({ redirect: true });
    }
    let isLoggedin = this.checklogion();
    if (isLoggedin == false) {
      this.props.history.push("/login");
    }
    await fetch(this.state.apiUrl + "manage-notifications", {
      method: "post",
      body: JSON.stringify({
        app_token: data.app_token,
        attribute_set_key: this.state.attribute_set_key,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        this.setState({
          agGridData: result.data,
          app_token1: result.app_token,
          attribute_set_key1: result.attribute_set_key,
        });
      });
  }
  ResetList(event) {
    if (event.key === "Backspace" || event.key === "delete") {
      this.getNotificationList();
    }
  }
  searchGrid = (event) => {
    const { name, value } = event.target;
    this.gridApi.setQuickFilter(value);
  };

  paginationSizeChange = (ev) => {
    this.setState(
      {
        ...this.state,
        perPage: {
          ...this.state.perPage,
          pagination_default_value: ev.target.value,
        },
      },
      () => {
        this.gridApi.paginationSetPageSize(
          this.state.perPage.pagination_default_value
        );
      }
    );
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  };
  onFirstDataRendered() {
    this.gridApi.sizeColumnsToFit();
  }
  NotificationMessage = (message) => {
    this.setState({
      notification_message: message,
    });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/login"} />;
    }
    const rowData = this.state.agGridData.map((item) => {
      return item;
    });
    const { app_token, attribute_set_key, attribute_set_name, agGridData } =
      this.state;

    const event_name = this.state.agGridData.map((item) => {
      return item.event_name;
    });

    const { emp_first_name } = this.props;
    const { filteredList } = this.state;
    return (
      <div class="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        <NotificationMessage response={this.state.notification_message} />
        <Header
          brecum_name="Manage Notifications"
          brecum_page={`Notification`}
        />
        <Container fluid>
          <div className="page-content pt-3 new-content-main">
            <Card className="border-0">
              <div className=" inline-edit-board border-bottom p-3">
                <Back to="/board/list" className="txt-dark underline-none" />
                Notifications
              </div>
              <Card.Body>
                <div className="mt-2">
                  <Row className="justify-content-end align-items-center gx-2">
                    <Col>
                      <div className="board-parent__division">
                        <div className="dropdown untitled-drop col-10">
                          <span className="inline-edit-board">
                            {attribute_set_name}
                          </span>
                        </div>
                      </div>
                    </Col>
                    <Col>
                      <Search
                        placeholder="Search Notification"
                        type="text"
                        onChange={this.searchGrid}
                      />
                    </Col>
                    <Col className="col-auto">
                      <span>
                        <TimeSvg />
                      </span>
                    </Col>
                    <Col className="col-auto">
                      <div class="icon-before font-weight-bold">
                        <div class="muBtn _blue">
                          <span class="svg">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 5V19"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M5 12H19"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </span>

                          <Link
                            to={{
                              pathname: `/${attribute_set_key}/manage-notifications/add`,
                              state: {
                                app_token,
                                attribute_set_key,
                                attribute_set_name,
                                event_name,
                              },
                            }}
                          >
                            Add Notification
                          </Link>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Row className="mt-3">
                  <Col md={12}>
                    <span className="loadingx"></span>
                    <div className="ag-grid-main-header">
                      <div
                        style={{ flex: 1, height: 300, width: "100%" }}
                        class="ag-theme-alpine"
                      >
                        <AgGridReact
                          rowData={rowData}
                          columnDefs={this.state.columnDefs}
                          defaultColDef={{
                            flex: 1,
                            floatingFilter: true,
                            filter: true,
                          }}
                          onGridReady={this.onGridReady}
                          animateRows={true}
                          pagination={true}
                          paginationPageSize={10}
                          onFirstDataRendered={this.onFirstDataRendered.bind(
                            this
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </Container>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getNotificationList,
};
export default ManageNotifications;
